module.exports = __webpack_public_path__ + "img/ic-phone-mobile-inactive.527f456e.svg";